import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

// {img: darkCamera, name: "Camera", sold: 334},
// {img: keyboard, name: "Keyboard", sold: 582},
// {img: hipsterHeadphones, name: "Headphones-2", sold: 760},
// {img: headphones, name: "Heaphones", sold: 549},
// {img: mouse, name: "Mouse", sold: 218},
export const data = {
  labels: ['Camera', 'Keyboard', 'Headphones-2', 'Heaphones', 'Mouse'],
  datasets: [
    {
      label: '# of Votes',
      data: [334, 582, 760, 549, 218],
      backgroundColor: [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

const DoughnutChart = () => {
  return <Doughnut className='m-4' data={data} />;
}

export default DoughnutChart